import { deleteApiCaller, getApiCaller, postFormDataApiCaller, putFormDataApiCaller, putApiCaller } from "../apiCaller";

export const getContent = async (search, currentPage, limit) => {
    const response = await getApiCaller(`content/get-all?search=${search}&page=${currentPage}&limit=${limit}&includeHidden=true`);
    return response;
}

export const addContent = async (payload) => {
    // Check if payload is already FormData
    if (payload instanceof FormData) {
        const response = await postFormDataApiCaller("content/create", payload);
        return response;
    }

    // Convert payload to FormData
    const formData = new FormData();

    formData.append('title', payload.title || '');
    formData.append('categoryId', payload.categoryId || '');
    formData.append('link', payload.link || '');
    formData.append('direction', payload.direction || 'ltr');
    formData.append('sequence', payload.sequence || '0');

    if (payload.image) {
        formData.append('image', payload.image);
    }
    if (payload.thumbnail) {
        formData.append('thumbnail', payload.thumbnail);
    }

    const response = await postFormDataApiCaller("content/create", formData);
    return response;
}

export const updateContent = async (id, payload) => {
    // Check if payload is already FormData
    if (payload instanceof FormData) {
        const response = await putFormDataApiCaller(`content/${id}`, payload);
        return response;
    }

    // Convert payload to FormData
    const formData = new FormData();

    formData.append('title', payload.title || '');
    formData.append('categoryId', payload.categoryId || '');
    formData.append('link', payload.link || '');
    formData.append('direction', payload.direction || 'ltr');
    formData.append('sequence', payload.sequence || '0');

    if (payload.image) {
        formData.append('image', payload.image);
    }
    if (payload.thumbnail) {
        formData.append('thumbnail', payload.thumbnail);
    }

    const response = await putFormDataApiCaller(`content/${id}`, formData);
    return response;
}

export const deleteContent = async (id) => {
    const response = await deleteApiCaller(`content/${id}`);
    return response;
}

export const getAllContent = async (currentPage, limit, search, categoryId = undefined) => {
    let url = `content/get-all?page=${currentPage}&limit=${limit}&search=${search || ""}&includeHidden=true`;
    if (categoryId !== undefined) {
        url += `&categoryId=${categoryId}`;
    }
    const response = await getApiCaller(url);
    return response;
}

export const contentSequence = async (payload) => {
    const response = await putFormDataApiCaller("content/sequence", payload);
    return response;
}

export const swapContentWithPage = async (payload) => {
    const response = await putApiCaller("content/swap-page", payload);
    return response;
}